/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Doc_Override_ConfirmInputs */

const en_doc_override_confirm = /** @type {(inputs: Doc_Override_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apply`)
};

const pt_br2_doc_override_confirm = /** @type {(inputs: Doc_Override_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aplicar`)
};

/**
* | output |
* | --- |
* | "Apply" |
*
* @param {Doc_Override_ConfirmInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const doc_override_confirm = /** @type {((inputs?: Doc_Override_ConfirmInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Doc_Override_ConfirmInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_doc_override_confirm(inputs)
	return pt_br2_doc_override_confirm(inputs)
});